import { render } from "./TopLevelLink.vue?vue&type=template&id=23a06e12&scoped=true"
import script from "./TopLevelLink.vue?vue&type=script&lang=js"
export * from "./TopLevelLink.vue?vue&type=script&lang=js"

import "./TopLevelLink.vue?vue&type=style&index=0&id=23a06e12&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a06e12"]])

export default __exports__